import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function addCoinToBriefcase(coinId) {
  const url = `${backendUrl}/api/widgets/user-assets/`;
  const formData = new FormData();
  formData.append('coin_id', coinId);

  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при добавлении монеты');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API addCoinToBriefcase error:', error);
    throw error;
  }
}